import { useMutation } from '@tanstack/react-query';
import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';
import { JobFieldSmartWriterRequest, JobFieldSmartWriterResponse } from 'clients/ReachoutClient/ReachoutClient.types';

export const useJobFieldSmartWriter = () => {
  return useMutation<JobFieldSmartWriterResponse, Error, JobFieldSmartWriterRequest>({
    mutationFn: (payload) => reachoutClient.callJobFieldSmartWriter(payload),
  });
};
